<template>
    <ion-toolbar>
        <ion-buttons slot="start"
            v-if="$store.state.pages.auth.back.length || routeName == 'profile_identity_documents'">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end" v-if="routeName == 'identity_document'">
            <ion-button class="pill next-pill-button" @click="skip">
                <span>Skip</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding ">
        <div class="container">
            <!-- <page-title title="Identity Document" subtitle="Please upload your documents!" /> -->
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>Identity Document</h1>
                    <p class="auth-subtext">Please upload your documents!</p>
                </div>
                <div class="brand-icon">
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
                </div>
            </div>
            <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
                :ref="(el) => (formsData.userForm.ref = el)" :label-position="'top'"
                @submit.prevent="goNext('userForm')">
                <el-form-item
                    :label="'In order to verify your identity, please provide a copy of your driving license or passport.'"
                    prop="documentType" v-if="files.length < 3">
                    <el-select v-model="formsData.userForm.type.value" class="m-0 w-100" placeholder="Select"
                        size="large">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </el-form-item>

                <el-form-item v-if="files.length <= 2">
                    <el-upload class="uploader-support" :action="'upload'"
                        :ref="(el) => (formsData.galleryForm.files.ref = el)" name="files" list-type="picture"
                        :thumbnail-mode="true" :on-preview="cropperMethods.handlePreview" :limit="3"
                        :on-exceed="cropperMethods.handleExceed" :drag="true" :on-change="cropperMethods.handleChange"
                        :before-upload="cropperMethods.beforeAvatarUpload">
                        <div class="file-uploader">
                            <div class="file-uploader-icon">
                                <img :src="require('@/assets/img/icons/upload.svg')" alt="upload" />
                            </div>
                            <div class="file-uploader-title">
                                Browse Your Files
                            </div>
                            <div class="file-uploader-description">
                                You can only upload file with JPG JPEG PNG JFIF SVG or PDF formats and
                                also file
                                maximum size 10MB.
                            </div>
                        </div>
                        <template #file="{ file }">
                            <div v-if="file.raw.type=='application/pdf'" class="el-upload-list__item-body">
                                <img class="el-upload-list__item-body-thumbnail"
                                    :src="require('@/assets/img/icons/pdf.svg')" />
                                <div class="el-upload-list__item-body-text">
                                    <span class="title" size="large">{{ file.name }}</span>
                                    <span class="description" size="large">{{ formatDate(file.lastModified) }}</span>
                                </div>
                            </div>
                            <div class="el-upload-list__item-body" v-else>
                                <img class="el-upload-list__item-body-thumbnail" :src="file.url" alt="" />
                                <div class="el-upload-list__item-body-text">
                                    <span class="title" size="large">{{ file.name }}</span>
                                    <span class="description" size="large">{{ formatDate(file.lastModified) }}</span>
                                </div>
                            </div>
                            <div class="el-upload-list__item-actions">
                                <button class="el-upload-list__item-actions-action"
                                    @click="cropperMethods.handleRemove(file)">
                                    <img :src="require('@/assets/img/icons/trash.svg')" />
                                </button>
                            </div>
                        </template>
                    </el-upload>
                </el-form-item>

                <div class="text-red mb-3"> (Maximum upload 3 files)</div>

                <el-form-item
                    v-if="routeName != 'profile_identity_documents' && files.length <= 3 && formsData.userForm.files.value.length <= 0"
                    class="button_submit mb0">
                    <el-button :disabled="disabled" class="submit" type="blue" @click="nextOnly('userForm')">
                        <span>Continue</span>
                    </el-button>
                </el-form-item>

                <el-form-item
                    v-else-if="routeName != 'profile_identity_documents' && formsData.userForm.files.value.length > 0"
                    class="button_submit mb0">
                    <el-button :disabled="disabled" class="submit" type="blue" @click="goNext('userForm')">
                        <span>Continue</span>
                    </el-button>
                </el-form-item>

                <el-form-item v-if="routeName == 'profile_identity_documents' && files.length <= 2"
                    class="button_submit mb0">
                    <el-button :disabled="disabled" class="submit" type="blue" @click="goNext('userForm')">
                        <span>Save</span>

                    </el-button>
                </el-form-item>
                <div class="form_text" v-else-if="routeName == 'profile_identity_documents' && files.length >= 3">
                    <div class="">
                        You have uploaded the max number of documents
                    </div>
                </div>
            </el-form>
            <div class="bg-overlay"></div>

            <div class="preview_square preview_square-block" v-if="files.length">
                <div class="proof-ins" v-if="isLicenceType4Exist">Drivers Licence Documents</div>
                <div class="el-upload-list">
                    <div class="el-upload-list__item" v-for="(file,index) in itemsWithTypeLicence" :key="file.url">

                        <div class="thumbnail_img el-upload-list--picture-card" v-if="file.type == 4">
                            <div v-if="file.extension == 'pdf'">
                                <img src="@/assets/img/default_pdf.svg" alt="" class="header_logo_text">
                            </div>
                            <div v-else>
                                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                            </div>

                            <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-preview" @click="docPreviewModalOpen(file)">
                                    <i class="el-icon-zoom-in"></i>
                                </span>
                                <span class="el-upload-list__item-delete" @click="fileDelete(file,index)">
                                    <i class="el-icon-delete"></i>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>

                <div class="proof-ins" v-if="isPassportType5Exist">Passport Documents</div>
                <div class="el-upload-list">
                    <div class="el-upload-list__item" v-for="(file,index) in itemsWithTypePassport" :key="file.url">

                        <div class="thumbnail_img el-upload-list--picture-card" v-if="file.type == 5">
                            <div v-if="file.extension == 'pdf'">
                                <img src="@/assets/img/default_pdf.svg" alt="" class="header_logo_text">
                            </div>
                            <div v-else>
                                <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                            </div>

                            <span class="el-upload-list__item-actions">
                                <span class="el-upload-list__item-preview" @click="docPreviewModalOpen(file)">
                                    <i class="el-icon-zoom-in"></i>
                                </span>
                                <span class="el-upload-list__item-delete" @click="fileDelete(file,index)">
                                    <i class="el-icon-delete"></i>
                                </span>
                            </span>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <div class="background-circles">
        <div class="circle circle-2"></div>
        <div class="circle circle-1"></div>
        <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none" />
    </div>
    <preview-modal :modalName="'previewModal'" :options="previewModal" />
</template>

<script>

import { onMounted, inject, ref, computed } from "vue";
import formHooks from "@/hooks/form/form";
import { addIcons } from "ionicons";
import { arrowBackOutline } from "ionicons/icons";
addIcons({
    "arrow-back-outline": arrowBackOutline,
});
import moment from 'moment';
import FileHelpers from "@/helpers/file/file";
import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";
import { useStore } from "vuex";
import { ElMessage, ElMessageBox } from "@/components/Vendor/Element";
import formValidate from "@/hooks/form/validate/validate";
import { useRouter, useRoute } from "vue-router";
import { PreviewModal } from "@/modals/modals";
// import PageTitle from "@/components/PageTitle/PageTitle.vue";
import SvgIcon from '@/components/Svg/SvgIcon.vue';

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
        "preview-modal": PreviewModal,
        SvgIcon
    },

    setup() {
        const $store = useStore();
        const $router = useRouter();
        const $route = useRoute();
        const setPageClassGlobal = inject(["setPageClassGlobal"]);
        const routeName = $route.name;
        const BASE_URL = process.env.VUE_APP_BASEURL;
        const userData = $store.getters.GET_USER_DATA;
        const identityType =  4;
        console.log("identity",identityType);
        const fileHelpers = new FileHelpers();
        const state = userData.address.state;
        let dialogVisible = true;
        let disabled = ref(true);
        const options = [
            {
                value: 4,
                label: 'Drivers Licence',
            },
            {
                value: 5,
                label: 'Passport',
            },
        ]
        const $modals = inject("$modals");
        const previewModal = ref({
            name: "identityDocument",
            file: [],
        });
        const docPreviewModalOpen = (file) => {
            if(file.extension == 'pdf'){
                window.open(file.url, '_blank');
            }else{
                previewModal.value.file = file;
                $modals.open("previewModal", {
                    file: file,
                });
            }
        };
        console.log(userData);
        const files = ref(userData.identityDocument);
        const itemsWithTypeLicence= computed(() => {
            return files.value.filter(item => item.type === 4)
        })
        const itemsWithTypePassport= computed(() => {
            return files.value.filter(item => item.type === 5)
        })
        const isLicenceType4Exist = files.value.some(obj => obj.type === 4);
        const isPassportType5Exist = files.value.some(obj => obj.type === 5);

        const formsDataArray = {
            userForm: {
                files: {
                    ref: null,
                    value: [],
                    limit: 1,
                    disabled: false,
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "gallery",
                                    callback,
                                    setFormValidation
                                );
                            },
                        },
                    ],
                    errors: null,
                },
                type: {
                    value: identityType ? identityType : 4,
                    resetValue: true,
                    validators: [
                        {
                            validator: (rule, formField, callback) => {
                                formValidate.validate(
                                    rule,
                                    formField,
                                    "documentType",
                                    callback,
                                    setFormValidation
                                );
                            },
                        },
                    ],
                },
            },
        };
        Object.assign(formsDataArray.userForm, formsDataArray);

        const onChangeUpload = () => {
            if (formsData.userForm.files.value.length > 0) {

                disabled.value = false;
            }else{
                disabled.value = true;
            }
        };
        const cropperMethods = {
            beforeAvatarUpload(file) {
                const img = URL.createObjectURL(file.raw);
                console.log(img);
            },
            handleRemove(file) {
                formsData.userForm.files.splice(
                    formsData.userForm.files.indexOf(file),
                    1
                );
                onChangeUpload();
            },
            handleChange(file, files) {
                const type = fileHelpers.getFileType(file);
                console.log(type);
                if (type == "image" || type == "pdf") {
                    formsData.userForm.files = files;
                    formsData.userForm.files.value = files;
                    checkFormValidation("userForm", true, "files");
                } else {
                    files.pop();
                    formsData.userForm.files.value = null;
                    ElMessage({
                        type: "error",
                        message: `Document must be JPG JPEG PNG JFIF or PDF format!`,
                    });
                }
                onChangeUpload();
            },

            handlePreview(/*file*/) {},
            handleExceed(file) {
                console.log(file);
                ElMessage({
                    type: "error",
                    message: `You can only upload one document here. `,
                });
            },
        };

        const goBack = async() => {
            if (routeName == "profile_identity_documents") {
                $router.push({
                    name: "profile_documents",
                });
            } else {
                const back = await $store.dispatch("getAuthPageBack");
                $router.push({
                    name: back,
                });
            }

        };

        const goNext = (formName) => {
            console.log("hello",formsData.userForm.files.value);
            formsRefs[formName].value.validate((valid) => {
                if (valid) {
                    const canvas = formsData.userForm.files.value;
                    const form = new FormData();
                    let counter = 0;
                    if(files.value.length != 0 && routeName == "identity_document" && canvas.length == 0){
                        $router.push({
                            name: "insurance_document",
                        });
                        return true;
                    }else if(files.value.length != 0 && routeName == "onboard_identity_document" && canvas.length == 0){
                        $router.push({
                            name: "onboard_insurance_document",
                        });
                        return true;
                    }
                    if (canvas.length != 0) {
                        canvas.map((item) => {
                            console.log("canvas",item);
                            form.append(`file[${counter}]`,  item.raw );
                            counter++;
                        });
                    } else {
                        ElMessage({
                            showClose: true,
                            type: "warning",
                            message: " Please upload the file",
                        });
                        console.log("error submit!!");
                        return false;
                    }
                    form.append(`fileType`,  formsData.userForm.type.value );
                    console.log("form",form);
                    (async () => {
                        try {
                            await $store.dispatch("SAVE_USER_DOCUMENT", form);
                            if (routeName == "profile_identity_documents") {
                                formsData.userForm.files.splice(0);
                
                                const getUserData = $store.getters.GET_USER_DATA;
                                
                                files.value = getUserData.identityDocument; 
                                // $router.push({
                                //     name: "profile_documents",
                                // });
                            }else if(routeName == "onboard_identity_document"){
                                $router.push({
                                    name: "onboard_insurance_document",
                                });

                            } else {
                                $router.push({
                                    name: "insurance_document",
                                });
                            }
                        } catch (error) {
                            console.log("error submit", error);

                            let item;
                            for (item in error) {
                                ElMessage({
                                    showClose: "true",
                                    type: "error",
                                    message: error[item][0],
                                });
                            }
                        }
                    })();

                }
            });
        };
        const skip = () => {
            (async () => {
                try {
                    await ElMessageBox.confirm(
                        ``,
                        "Do you want to skip? You will be unverified",
                        {
                            distinguishCancelAndClose: true,
                            showConfirmButton: true,
                            confirmButtonText: "Skip",
                            cancelButtonText: "Cancel",
                            confirmButtonClass: "el-button--green",
                            cancelButtonClass: "el-button--grey",
                            showClose: true,
                        }
                    );
                } catch {
                    return;
                }
                try {
                    await $store.dispatch("addAuthPageBack", $route.name);
                    if(routeName == "onboard_identity_document"){
                        $router.push({
                            name: "onboard_insurance_document",
                        });
                    }else{
                        $router.push({
                            name: "insurance_document",
                        });
                    }
                } catch (error) {
                    console.log(error);
                }
            })();


        };

        const nextOnly = () => {
            (async () => {

                try {
                    await $store.dispatch("addAuthPageBack", $route.name);
                    if(routeName == "onboard_identity_document"){
                        $router.push({
                            name: "onboard_insurance_document",
                        });
                    }else{
                        $router.push({
                            name: "insurance_document",
                        });
                    }

                } catch (error) {
                    console.log(error);
                }
            })();


        };

        onMounted(() => {
            setPageClassGlobal("global_auth_page");
            checkFormValidation("userForm", false);
            setFormRefs();
            if (files.value.length > 0 && routeName != "profile_identity_documents"){
                console.log("hello i'm in");
                disabled.value = false;
            }
        });



        const fileDelete = async (file,index) => {
            try {
                console.log("deleted files",file );
                console.log("This is the index", index)
                await ElMessageBox.confirm(
                    `Are you sure you’d like to remove file ?`,
                    "Remove file",
                    {
                        confirmButtonText: "Remove",
                        cancelButtonText: "Cancel",
                        confirmButtonClass: "el-button--red",
                        cancelButtonClass: "el-button--grey",
                        showClose: false,
                    }
                );
                await $store.dispatch("DELETE_USER_DOCUMENT", file);

                files.value = files.value.filter( item =>  file.id != item.id );
            } catch (error) {
                console.log(error);
            }
        };

        const {
            checkFormValidation,
            setFormValidation,
            formsRefs,
            setFormRefs,
            getFormValues,
            formsData,
        } = formHooks(formsDataArray);

        return {
            formsData,
            goBack,
            goNext,
            checkFormValidation,
            routeName,
            cropperMethods,
            fileDelete,
            files,
            state,
            BASE_URL,
            getFormValues,
            docPreviewModalOpen,
            previewModal,
            dialogVisible,
            options,
            skip,
            disabled,
            onChangeUpload,
            nextOnly,
            isLicenceType4Exist,
            isPassportType5Exist,
            itemsWithTypeLicence,
            itemsWithTypePassport,
            formatDate: (date) => {
                return moment(date).format('ll');
            }
        };
    },
};
</script>
